/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module StudioFavourite
 *
 * This module helps getting and setting a favourite by user analysis and user actions
 */
(function StudioFavourite() {
    /**
     * @constructor
     */
    function StudioFavourite() {
        /**
         * // local object availability
         * @type {StudioSelect}
         * @private
         */
        var _this = this;

        /**
         * Name for storage key entry
         * @type {string}
         */
        var possibleFavouriteStorageName = 'possible-studio-favourite';

        /**
         * Name for storage key entry
         * @type {string}
         */
        var bookmarkStorageName = 'bookmark-studio-favourite';

        /**
         * Sets possible favourite. This should by called automatically depending on user behavior
         * @param identifier
         */
        this.setPossibleFavourite = function(identifier) {
            localStorage.setItem(possibleFavouriteStorageName, identifier);
        };

        /**
         * Sets a bookmark means most important studio. Should be called if user explicitly wants to bookmark a favourite.
         * Can also be used to unset the bookmark by providing "null" as parameter
         * @API
         * @param {string | null} identifier
         */
        this.setBookmark = function(identifier) {
            if(identifier === null) {
                localStorage.removeItem(bookmarkStorageName);
            } else {
                localStorage.setItem(bookmarkStorageName, identifier);
            }
        };

        /**
         * Check if user had set a bookmark
         * @API
         * @returns {boolean}
         */
        this.isBookmarked = function() {
            let favourite = localStorage.getItem(bookmarkStorageName);
            return favourite !== null;
        };

        /**
         * Gets the most likely favourite candidate
         * @API
         * @returns {string | null}
         */
        this.getLikelyStudioIdentifier = function () {
            let favourite = localStorage.getItem(bookmarkStorageName);
            if(favourite !== null) {
                return favourite;
            }
            // returns null if no entry was found
            return localStorage.getItem(possibleFavouriteStorageName);
        };
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.StudioFavourite = StudioFavourite;
})();

function studioPageReady(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState != 'loading')
                fn();
        });
    }
}

function initJumpersStudioFavourite() {
    let studioFavouriteComponent = document.querySelector('.js-studio-page');
    // only if current page is a studio page
    if (studioFavouriteComponent) {
        let favourite = new window.Jumpers.StudioFavourite();
        // set current studio page as possible favourite
        favourite.setPossibleFavourite(studioFavouriteComponent.dataset.studioId);
    }
}

studioPageReady(initJumpersStudioFavourite);
